<script setup>
import {inject, ref} from "vue";
import {router} from '@inertiajs/vue3';
import Swal from 'sweetalert2';
import ConfirmDeleteModal from '@/components/Dashboard/ConfirmDeleteModal';

const props = defineProps({
  integration: Object,
  user: Object,
})

const emit = defineEmits(['deleted'])

const showModal = ref(false)

const trans = inject('trans')

const handleRedirectIntegration = () => {
  router.visit(route('dashboard.user.integrations.overview', {user: props.user.id, integration: props.integration.id}))
}

const handleConfirmDelete = (event) => {
  event.stopPropagation();
  showModal.value = true;
}

const handleDeleteIntegration = () => {
  axios
    .delete(`/user/${props.user.id}/integration/${props.integration.id}`)
    .then(() => {
      Swal.fire({
        text: trans('dashboard.alerts.success_delete_integration'),
        icon: 'success',
        showConfirmButton: false,
        timer: 2000,
      });

      emit('deleted');
    })
    .catch(err => {
      Swal.fire({
        text: err.data.message,
        icon: 'error',
        showConfirmButton: false,
        timer: 2000,
      });
    })
    .finally(() => showModal.value = false);
}
</script>
<template>
  <div class="integration-tile position-relative">
    <div v-if="integration.label" class="integration-label position-absolute text-center">
      <div class="integration-label-alert alert font-weight-bold" :class="`alert-${integration.label.style}`">
        {{ integration.label.message }}
      </div>
    </div>
    <div class="tile tile-wide cursor-pointer overflow-hidden h-100" @click="handleRedirectIntegration">
      <div class="tile_column">
        <h3 class="h5 tile-title">{{ integration.first_application.alias }}</h3>
        <div class="flex align-items-center justify-content-center my-2" style="width: 100px; height: 100px">
          <img
            class="img-fluid"
            :src="integration.first_application.logo_url"
            :alt="integration.first_application.name"
          />
        </div>
      </div>
      <div class="tile_column">
        <h3 class="h5 tile-title">{{ integration.second_application.alias }}</h3>
        <div class="flex align-items-center justify-content-center my-2" style="width: 100px; height: 100px">
          <img
            class="img-fluid"
            :src="integration.second_application.logo_url"
            :alt="integration.second_application.name"
          />
        </div>
      </div>
      <div class="tile_bar">
        <button class="tile-button has-tooltip">
          <svg class="icon rotate-90">
            <use xlink:href="#dots-vertical"></use>
          </svg>
        </button>
        <button
          v-if="$can('integrations.delete')"
          class="tile-button has-tooltip"
          @click="handleConfirmDelete"
        >
          <svg class="icon">
            <use xlink:href="#delete-icon"></use>
          </svg>
        </button>
        <button :class="integration.status" class="text-center tile-button"></button>
      </div>
    </div>
    <confirm-delete-modal
      v-if="showModal"
      :name="`delete-integration-` + integration.id"
      content=""
      :header="trans('dashboard.integrations.delete_integration_confirmation_title')"
      @close="showModal = false"
      @confirm="handleDeleteIntegration"
    >
      <div class="content"
           v-html="trans('dashboard.integrations.delete_integration_confirmation_description', {first: integration.first_application.alias, second: integration.second_application.alias})"/>
    </confirm-delete-modal>
  </div>
</template>
<style>
.integration-label,
.integration-label-alert {
  height: 2rem;
}

.integration-label {
  position: absolute;
  bottom: -1rem;
  width: calc(100% - 6rem);
  z-index: 2;
  text-align: center;
}

.integration-label-alert {
  display: inline-block;
  padding: 0 1.25rem;
  line-height: 2;
}

.tile-title {
  text-align: center;
}
</style>
